import { DatePipe, DOCUMENT, LowerCasePipe, NgFor, NgIf } from '@angular/common';
import { Component, Inject, Renderer2, ViewEncapsulation } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { Brand } from '../../models/brand';
import { Category } from '../../models/category';
import { Coupon } from '../../models/coupon';
import { Deal } from '../../models/deal';
import { PageMeta } from '../../models/page-meta';
import { ReplaceMetaDatePipe } from '../../pipes/replace-meta-date.pipe';
import { BrandApiService } from '../../services/brand-api.service';
import { CategoryApiService } from '../../services/category-api.service';
import { DealApiService } from '../../services/deal-api.service';
import { PagesApiService } from '../../services/pages-api.service';

@Component({
  selector: 'app-free-shipping',
  imports: [NgIf, NgFor, DatePipe, LowerCasePipe, RouterModule, ReplaceMetaDatePipe],
  templateUrl: './free-shipping.component.html',
  styleUrl: './free-shipping.component.css',
  encapsulation: ViewEncapsulation.None
})
export class FreeShippingComponent {
  pageTitle: string = '';
  breadcrumTitle: string = '';
  coupons: Coupon[] = [];
  offers: Coupon[] = [];
  categories: Category[] = [];
  urlParam: string | null = '';
  today: Date = new Date();
  isReview = false;
  brands: Brand[] = [];
  allItems: Coupon[] = [];
  pendingApiCalls: number = 0;
  isFaq: boolean = false;
  isDataLoaded: boolean = false;
  pagemeta: PageMeta[] = [];
  activeTab = 'all';
  isDeal: boolean = false;

  constructor(
    private couponApi: DealApiService,
    private categoryApi: CategoryApiService,
    private brandApi: BrandApiService,
    private siteApi: PagesApiService,
    private meta: Meta,
    private title: Title,
    private replaceMetaPipe: ReplaceMetaDatePipe,
    @Inject(DOCUMENT) private dom: Document,
    private renderer: Renderer2
  ) {
    this.loadAllData();
  }

  loadAllData() {
    this.pendingApiCalls = 4;

    this.pageTitle = 'freeshipping';
    this.getTopCategories();
    this.getTopBrands();
    if (this.pageTitle === 'freeshipping') {
      this.breadcrumTitle = 'Free Shipping';
      this.getFreeShippingCoupons();
      this.getPageMeta('freeshipping');
    }
  }

  checkIfAllDone() {
    this.pendingApiCalls--;
    if (this.pendingApiCalls === 0) {
      this.isDataLoaded = true;
    }
  }

  public loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  ngOnInit() { }

  getFreeShippingCoupons() {
    this.couponApi.getHeaderCoupons(0, 1, 2).subscribe((data) => {
      if (data.Message === 'Data Fetched Successfully!!!') {
        this.coupons = data.Data.filter((coupon) => coupon.CouponCode != '');
        this.offers = data.Data.filter((coupon) => coupon.CouponCode == '');
        this.allItems = data.Data;
        this.activeTab =
          this.coupons.length > 0
            ? this.offers.length > 0
              ? 'all'
              : 'coupons'
            : 'offers';
      } else {
      }
      this.checkIfAllDone();
    });
  }

  getTopCategories() {
    this.categoryApi.getTopCategories(1).subscribe((data) => {
      if (data.Message === 'Data Fetched Successfully!!!') {
        this.categories = data.Data;
      } else {
      }
      this.checkIfAllDone();
    });
  }

  getTopBrands() {
    this.brandApi.getStores(1, 1, 10).subscribe((data) => {
      if (data.Message === 'Data Fetched Successfully!!!') {
        this.brands = data.Data;
      } else {
      }
      this.checkIfAllDone();
    });
  }

  directToNotFoundPage() {
    window.location.href = `not-found`;
  }

  directToCouponCodePage(coupon: Coupon) {
    const url = coupon.CouponUrl;
    window.open(url!, '_blank');
    window.location.href = `coupon-code/${coupon.CouponId}/`;
  }

  directToBrandPageDeals(deal: Deal) {
    if (deal) {
      let seoName = deal.StoreName?.toLowerCase().replace(' ', '-');
      window.location.href = `${seoName}-coupons/`;
    } else {
      console.error('Deal is undefined or invalid:', deal);
    }
  }

  directToCommonPageDeals(): void {
    if (this.title) {
      const couponUrl = `${this.title}`;
      window.location.href = couponUrl;
    } else {
      console.error('Category or category name is undefined:', this.title);
    }
  }

  directToCommonPageCoupons(): void {
    if (this.title) {
      const couponsUrl = `${this.title}`;
      window.location.href = couponsUrl;
      // Recommended: Use router navigation instead
      // this.router.navigate([couponsUrl]);
    } else {
      console.error('Category name is undefined or invalid:', this.title);
    }
  }

  collapseStates: { [key: number]: boolean } = {};

  onCollapseChange(i: number, isExpanded: boolean) {
    this.collapseStates[i] = isExpanded;
  }

  collapseExpanded(i: number): boolean {
    return this.collapseStates[i] || false;
  }

  // directToCategoryCoupons(cat: Category) {
  //   if (cat && cat.CategoryId > 0) {
  //     window.location.href = `coupons/${cat.CategorySEOName}/`;
  //   } else {
  //     console.error('Cat ID is undefined or invalid:');
  //   }
  // }

  updateMetaData(data: PageMeta) {
    const pageTitle = this.replaceMetaPipe.transform(data.PageTitle!);
    const pageDescription = this.replaceMetaPipe.transform(data.PageDescription!);
    const pageUrl = `https://www.dealszo.com/${this.pageTitle}`;
    // const keyWords = data.PageKeywords!;

    // Update the title and meta tags dynamically
    this.title.setTitle(pageTitle);
    this.meta.updateTag({ name: 'title', content: pageTitle });
    this.meta.updateTag({ name: 'description', content: pageDescription });
    // this.meta.updateTag({
    //   name: 'keywords',
    //   content: keyWords,
    // });

    this.meta.updateTag({
      name: 'robots',
      content:
        'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
    });

    // Open Graph meta tags
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:site_name', content: 'dealszo.com' });
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({
      property: 'og:description',
      content: pageDescription,
    });
    // this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({ property: 'og:url', content: pageUrl });

    let link: HTMLLinkElement = this.dom.querySelector(
      `link[rel='canonical']`
    )!;
    let alternativeLink: HTMLLinkElement = this.dom.querySelector(
      `link[rel='alternate']`
    )!;
    if (link) {
      this.renderer.setAttribute(link, 'href', pageUrl);
    } else {
      link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'canonical');
      this.renderer.setAttribute(link, 'href', pageUrl);
      this.renderer.appendChild(this.dom.head, link);
    }
    if (alternativeLink) {
      this.renderer.setAttribute(alternativeLink, 'href', pageUrl);
    } else {
      link = this.renderer.createElement('link');
      this.renderer.setAttribute(alternativeLink, 'rel', 'canonical');
      this.renderer.setAttribute(alternativeLink, 'href', pageUrl);
      this.renderer.appendChild(this.dom.head, link);
    }

    if (data.PageSchema && data.PageSchema.trim() !== '') {
      const schema = this.replaceMetaPipe.transform(data.PageSchema);
      const jsonLdScripts = this.dom.head.querySelectorAll(
        'script[type="application/ld+json"]'
      );
      jsonLdScripts.forEach(script => script.remove());
      const temp = this.dom.createElement('div');
      temp.innerHTML = schema;
      const scripts = temp.querySelectorAll(
        'script[type="application/ld+json"]'
      );
      scripts.forEach((scriptTag, index) => {
        const newScript = this.dom.createElement('script');
        newScript.type = 'application/ld+json';
        newScript.id = `schema-jsonld-${index}`;
        newScript.text = scriptTag.textContent || '';
        this.dom.head.appendChild(newScript);
      });
    }
  }

  getPageMeta(page: string) {
    this.siteApi.getPagesMeta().subscribe((data) => {
      if (data.Message === 'Data Fetched Successfully!!!') {
        this.pagemeta = data.Data;
        this.updateMetaData(
          this.pagemeta.find((p) => p.PageName?.includes(page))!
        );
      } else {
      }
      this.checkIfAllDone();
    });
  }

  itemTitle(item: Coupon | Deal): string {
    return this.isDeal
      ? (item as Deal).DealTitle || ''
      : (item as Coupon).CouponTitle || '';
  }

  itemDescription(item: Coupon | Deal): string {
    return this.isDeal
      ? (item as Deal).DealDescription || ''
      : (item as Coupon).CouponDescription || '';
  }

  itemHasCode(item: Coupon | Deal): boolean {
    return this.isDeal
      ? !!(item as Deal).DealCode
      : !!(item as Coupon).CouponCode;
  }

  itemVerified(item: Coupon | Deal): boolean {
    return this.isDeal
      ? !!(item as Deal).DealVerify
      : !!(item as Coupon).CouponVerify;
  }

  itemBadge(item: Coupon | Deal, defaultLabel: string): string {
    const label = this.isDeal
      ? (item as Deal).DealOfferTitle
      : defaultLabel == 'OfferTitle' ? (item as Coupon).OfferTitle : (item as Coupon).CoupounOfferTitle;
    return label || '';
  }

  itemExpiry(item: Coupon | Deal): string {
    const date = this.isDeal
      ? (item as Deal).DealEndDate
      : (item as Coupon).CouponEndDate;
    return date ? `Expires: ${new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}` : 'On Going';
  }

  itemStoreName(item: Coupon | Deal): string {
    return item.StoreName || 'Store';
  }

  itemStoreLogo(item: Coupon | Deal): string {
    return item.StoreLogo || '';
  }

  itemSeoName(item: Coupon | Deal): string {
    return item.SeoName || '';
  }

  verifiedItemCount(): number {
    return this.listingItems().filter((item) => this.itemVerified(item)).length;
  }

  listingItems(): Array<Coupon | Deal> {
    return this.isDeal ? [] : this.allItems;
  }

  openItem(item: Coupon | Deal): void {
    if (this.isDeal) {
      //this.directToDealCodePage(item as Deal);
    } else {
      this.directToCouponCodePage(item as Coupon);
    }
  }
}
